import { post, get, put, del } from "@/utils/request";

// 考试任务列表考官
export function getExamList(data) {
    return get("/api/exam/exam", data);
}
// 考试任务列表考生
export function getExamineeExamList(data) {
    return post("/api/exam/exam/getExamineeCultivateList?pageSize=" + data.pageSize + "&pageNum=" + data.pageNum, data);
}

// 考试任务详情列表
export function getExamTaskDetailList(data) {
    return post("/api/exam/exam/cultivateDetail?pageSize=" + data.pageSize + "&pageNum=" + data.pageNum, data);
}

// 获取考试任务状态及题目
export function getExamTaskStatus(id) {
    return get("/api/exam/exam/toExam/" + id);
}

// 保存考试文档查看进度
export function saveFileProcess(data) {
    return post("/api/exam/cultivate/saveWatchProcess", data);
}
// 获取负责人列表
export function getUserList(data) {
    return get("/api/exam/admin/adminList", data);
}

//考试任务前置检查
export function checkExamTask(data) {
    return get("/api/exam/exam/examFrontCheck", data)
}

//获取考生历史考试列表
export function examHistory(data) {
    return get("/api/exam/exam/cultivateDetailHistory/" + data.id + "/" + data.uid, data)
}

//提交考试
export function submitExam(data) {
    return post("/api/exam/exam/savePracticePaper", data)
}

//考试关联的培训任务
export function getExamTrainList(id) {
    return get("/api/exam/exam/getCultivateList/" + id)
}

//获取考试试卷
export function toExam(id) {
    return get("/api/exam/exam/toExam/" + id)
}

export function toExamQuestion(params) {
    return get("/api/exam/exam/questions", params)
}

// 重新练习：生成培训试卷
export function redoTrainTaskQuestion(data) {
    return get("/api/exam/exam/questions/reset", data);
}
